import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=49011f3d&scoped=true&"
import script from "./Testimonial.vue?vue&type=script&lang=js&"
export * from "./Testimonial.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Testimonial.vue?vue&type=style&index=0&id=49011f3d&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "49011f3d",
  "6009c3b0"
  
)

export default component.exports